import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './livepreview.css';

const ViewComponent = () => {
    const { id } = useParams();
    const [sourcecode, setSourcecode] = useState('');

    useEffect(() => {
        if (id) {
            axios.get(`https://quickreact.onrender.com/getComponent/${id}`)
                .then(response => {
                    setSourcecode(response.data);
                })
                .catch(error => {
                    console.error("Error fetching component:", error);
                    setSourcecode(''); 
                });
        }
    }, [id]);

    return (
        <div className='live-view'>
             <h1>Live Preview</h1>
            {sourcecode ? (
                <iframe
                    title={`Dynamic Component`}
                    srcDoc={`
                        <html>
                            <head>
                                <style>
                                ${sourcecode.csscode}   
                                </style>
                            </head>
                            <body>
                                ${sourcecode.htmlcode}
                                <script>
                                    document.addEventListener('contextmenu', function(e) {
                                        e.preventDefault();
                                    });

                                    document.addEventListener('keydown', function(e) {
                                        if (e.key === 'F12' || 
                                            (e.ctrlKey && e.shiftKey && e.key === 'I') ||
                                            (e.ctrlKey && e.shiftKey && e.key === 'J') ||
                                            (e.ctrlKey && e.key === 'U')) {
                                            e.preventDefault();
                                        }
                                    });
                                </script>
                            </body>
                        </html>
                    `}
                    style={{ width: '100%', height: '800px'  }}
                />
            ) : (
                <p>Loading or component not found...</p>
            )}
        </div>
    );
};

export default ViewComponent;
